module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calculator fa-fw"
  }), _vm._v(" "), (_vm.closed) ? _c('span', [_c('div', {
    staticClass: "coverage-indicator",
    class: {
      'bad': _vm.project.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(_vm.project.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(_vm.project.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
    }
  })]) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(_vm.minubaBudget && !_vm.loading) ? _c('div', [_c('table', {
    staticStyle: {
      "white-space": "nowrap",
      "margin": "0 -10px",
      "font-size": "12px"
    },
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Tilbud")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Ordre")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Realiseret til dato")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "3px 10px 3px 20px",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Difference")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Omsætning")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.invoices_total)))]), _vm._v(" "), _c('td', {
    class: {
      'bad': (_vm.project.minuba_price - _vm.project.invoices_total) < 0
    },
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price - _vm.project.invoices_total)))])]), _vm._v(" "), _vm._l((_vm.filteredBudgetLines), function(budgetLine, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "padding": "3px 10px"
      },
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(budgetLine.type))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px 10px"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(budgetLine.proposal_cost)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px 10px"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(budgetLine.order_cost)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px 10px"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(budgetLine.expended_cost)))]), _vm._v(" "), _c('td', {
      class: {
        'bad': (budgetLine.order_cost - budgetLine.expended_cost) < 0
      },
      staticStyle: {
        "padding": "3px 10px",
        "font-style": "italic"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(budgetLine.order_cost - budgetLine.expended_cost)))])])
  }), _vm._v(" "), (_vm.notBudgetted() > 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Ikke budgetteret")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.notBudgetted())))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.notBudgetted())))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "0",
      "padding": "0",
      "margin": "0"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Omkostning")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.minubaBudget.budget_lines, 'proposal_cost'))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.minubaBudget.budget_lines, 'order_cost'))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())))]), _vm._v(" "), _c('td', {
    class: {
      'bad': (_vm.sum(_vm.minubaBudget.budget_lines, 'order_cost') - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())) < 0
    },
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.minubaBudget.budget_lines, 'order_cost') - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted()))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Dækningsbidrag")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'proposal_cost'))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost'))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted()))))]), _vm._v(" "), _c('td', {
    class: {
      'bad': ((_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())) - (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost'))) < 0
    },
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")((_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())) - (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost')))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Dækningsgrad")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.ccp(_vm.project.minuba_price, (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'proposal_cost')))) + " %")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.ccp(_vm.project.minuba_price, (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost')))) + " %")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.closed) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.ccp(_vm.project.invoices_total, (_vm.project.minuba_price - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())))) + " %\n                                ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.closed) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.ccp(_vm.project.invoices_total, (_vm.project.minuba_price - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted()))) - _vm.ccp(_vm.project.minuba_price, (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost')))) + " %\n                                ")]) : _c('span', [_vm._v("-")])])])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "text-align": "center"
    }
  }, [(!_vm.closed) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-weight": "600"
    }
  }, [(_vm.closed) ? _c('span', [_vm._v("\n                                Lønsomhed: " + _vm._s(_vm._f("currency")(_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted()))) + "\n                            ")]) : _c('span', [_vm._v("\n                                Færdiggørelsesgrad: " + _vm._s(Math.round(_vm.project.completion_rate)) + " %\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.closed) ? _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "height": "16px",
      "width": "100px",
      "background": "#ddd",
      "border-radius": "100px",
      "overflow": "hidden",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    }
  }, [((_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())) > 0) ? _c('div', {
    staticStyle: {
      "height": "16px",
      "background": "#4CAF50"
    }
  }) : _c('div', {
    staticStyle: {
      "height": "16px",
      "background": "#FF5252"
    }
  })]) : _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "height": "16px",
      "width": "100px",
      "background": "#ddd",
      "border-radius": "100px",
      "overflow": "hidden",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    }
  }, [_c('div', {
    style: (("height:16px;background:" + (_vm.project.completion_rate > 99 ? '#FF5252' : _vm.project.completion_rate > 80 ? '#FFA000' : '#4CAF50') + ";width:" + (Math.ceil((100 / 100) * _vm.project.completion_rate)) + "px;max-width:100px;"))
  }, [_vm._v(" ")])])]), _vm._v(" "), (!_vm.closed) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "normal"
    }
  }, [_vm._v("Realiserede ift. budgetterede omkostninger")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.closed) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                            DB pr. time\n                        ")]), _vm._v(" "), _c('div', [(_vm.project.coverage_per_hour !== null) ? _c('div', {
    staticClass: "coverage-indicator",
    class: {
      'bad': _vm.project.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(_vm.project.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(_vm.project.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
    }
  }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.project.coverage_per_hour)) + " \n                        ")])]) : _vm._e()])]) : _c('div', [(_vm.loading) ? _c('div', [_vm._v("\n                    Indlæser ...\n                ")]) : _c('div', [_vm._v("\n                    Hov, vi kunne ikke hente budgettet.\n                ")])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d680023"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/MinubaBudgetTooltip.vue
// module id = 861
// module chunks = 0